import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@/services/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { AppConstants } from '@/helpers/app.constants';
import { AlertService } from '@/services/alert.service';

@Component({
    selector: 'app-login-callback',
    templateUrl: './login-callback.component.html',
    styleUrls: ['./login-callback.component.scss'],
    standalone: true
})
export class LoginCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.alertService.success('Authentification réussie', false);
    this.route.fragment.subscribe(fragment => {
      const params = new URLSearchParams(fragment);
      this.authenticationService.connectUser(
        params.get(AppConstants.PARAM_ID_TOKEN),
        params.get(AppConstants.PARAM_STATE)
      );
    });
  }
}
